// stores/global.js
import { ref, watch } from 'vue';  // 添加 watch 导入

// 创建全局响应式变量
export const globalLanguage = ref('EN');

// 设置语言的方法
export const setGlobalLanguage = (lang) => {
  globalLanguage.value = lang;
  const currentUrl = window.location.href;
  if(!(currentUrl.indexOf('/detail')>-1) ){
    localStorage.setItem('globalLanguage', lang);
  }
};

// 初始化语言
export const initGlobalLanguage = () => {
  const savedLang = localStorage.getItem('globalLanguage');
  if (savedLang) {
    globalLanguage.value = savedLang;
  }
};

// 监听语言变化并更新 body 类名
export const initLanguageWatcher = () => {
  // 初始设置
  updateBodyClass(globalLanguage.value);
  
  // 监听语言变化
  watch(globalLanguage, (newLang) => {
    updateBodyClass(newLang);
  });
};

// 更新 body 类名
const updateBodyClass = (lang) => {
  const body = document.body;
  // 移除所有语言类名
  body.classList.remove('lang-en', 'lang-tc', 'lang-sc');
  
  // 添加当前语言类名
  if (lang === 'EN') {
    body.classList.add('lang-en');
  } else if (lang === 'TC') {
    body.classList.add('lang-tc');
  } else if (lang === 'SC') {
    body.classList.add('lang-sc');
  }
};